import Styles from "./NoImagePlaceholder.module.scss";
import {ReactComponent as PhotosIcon} from "../../../icons/extra_icons/photos.svg"

const NoImagePlaceholder = () => {
  return (
    <div className={Styles.container}>
        <div className={Styles.image}>
            <PhotosIcon/>
        </div>
        <div className={Styles.label}>Gallery is empty</div>
    </div>
  )
}

export default NoImagePlaceholder
